module.exports = __webpack_public_path__ + "static/media/wireframe3@4x.7605c7d5.png";